import { isDevOrSandbox } from 'src/products/connector/pages/add-connector/utils';
import { RenderTheStepsArgs, RenderTheStepsReturn } from './model';

export const renderTheSteps = ({
  chosenSource,
  repeatedSource,
}: RenderTheStepsArgs): RenderTheStepsReturn => {
  if (isDevOrSandbox() && chosenSource) {
    return true;
  }

  return chosenSource && !repeatedSource;
};
